(function () {
  'use strict';

  angular.module('ringbaPortal').component('offerNextSteps', {
    bindings: {
      isPublisher: '<',
      campaignId: '<',
      showCampaignTab: '&',
      openOfferDraft: '&',
      hidePanel: '&'
    },
    controller: offerNextStepsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/offer/next-steps.view.html'
  });

  function offerNextStepsController(
    $timeout,
    userSettingsService,
    utils
  ) {
    'ngInject';

    const vm = this;
    vm.hideOfferNextStep = hideOfferNextStep;
    vm.scrollToPanel = scrollToPanel;
    vm.cancelHideNextStepsPanel = cancelHideNextStepsPanel;

    function hideOfferNextStep() {
      vm.hidePanel();
      return userSettingsService.getUserSettings().then(function (settings) {
        if (!settings.offerNextSteps) {
          settings.offerNextSteps = {};
        }
        settings.offerNextSteps[vm.campaignId] = false;
        if (vm.hideAllNextSteps) {
          settings.neverShowOfferNextSteps = true;
        }
        return userSettingsService.saveUserSettings(settings);
      });
    }

    function cancelHideNextStepsPanel() {
      vm.showConfirmation = false;
    }

    function scrollToPanel(stepNumber, isPub) {
      let panelId,
        showCampaignTab = false,
        scrollOffset = 52;
      switch (stepNumber) {
      case 1:
        panelId = isPub ? 'panel-publisher-number' : 'panel-payout-settings';
        showCampaignTab = true;
        break;
      case 2:
        panelId = isPub ? 'panel-payout-settings' : 'panel-publisher-number';
        showCampaignTab = true;
        break;
      case 3:
        if (isPub) {
          panelId = 'panel-offer-details';
          scrollOffset = 120;
        } else {
          panelId = 'panel-offer-draft';
          scrollOffset = 0;
          vm.openOfferDraft();
        }
        break;
      case 4:
        panelId = 'panel-number-restrictions';
        break;
      default:
        return;
      }

      if (showCampaignTab) {
        vm.showCampaignTab();
      }

      $timeout(function () {
        utils.scrollToElementId(panelId, scrollOffset);
      }, 200);

    }
  }
})();
